import { Tag, Spin } from 'antd'
import { useState } from 'react'
import { CheckCircleFilled, CloseCircleFilled, LoadingOutlined, MinusCircleFilled, RightOutlined, DownOutlined } from '@ant-design/icons'
import { ToolCallPart, ToolResultPart } from './aiAssistantModel'
import { ToolCallStatus, toolCallStatus, toolLabel } from './messageBubbleModel'
import { toolTagStyle } from './toolCallStyles'

type Props = {
  callPart: ToolCallPart
  resultPart?: ToolResultPart
  expandable?: boolean
  isHistorical?: boolean
  compactToolCalls?: boolean
}

export const ToolStatusIcon = ({ status }: { status: ToolCallStatus }) => {
  switch (status) {
    case 'running':
      return <Spin indicator={<LoadingOutlined style={{ fontSize: 12 }} spin />} size="small" />
    case 'no_result':
      return <MinusCircleFilled style={{ color: '#d9d9d9', fontSize: 12 }} />
    case 'error':
      return <CloseCircleFilled style={{ color: '#ff4d4f', fontSize: 12 }} />
    default:
      return <CheckCircleFilled style={{ color: '#52c41a', fontSize: 12 }} />
  }
}

const ToolCallGroup = ({ callPart, resultPart, expandable, isHistorical, compactToolCalls }: Props) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div style={{ margin: '4px 0' }}>
      <Tag
        onClick={expandable ? () => setExpanded(!expanded) : undefined}
        style={{
          ...toolTagStyle(!!compactToolCalls),
          cursor: expandable ? 'pointer' : 'default',
        }}
      >
        {expandable && (
          expanded
            ? <DownOutlined style={{ fontSize: 10 }} />
            : <RightOutlined style={{ fontSize: 10 }} />
        )}
        <ToolStatusIcon status={toolCallStatus(resultPart, !!isHistorical)} />
        {toolLabel(callPart, !!compactToolCalls)}
      </Tag>
      {expandable && expanded && (
        <div style={{
          marginTop: 4,
          marginLeft: 8,
          padding: 8,
          background: '#fafafa',
          border: '1px solid #f0f0f0',
          borderRadius: 6,
          fontSize: 12,
          fontFamily: 'monospace',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}>
          {compactToolCalls && (
            <div style={{ marginBottom: 8 }}>
              <span style={{ fontWeight: 600 }}>Tool </span>
              {callPart.tool_name}
            </div>
          )}
          {Object.keys(callPart.arguments).length > 0 && (
            <div>
              <div style={{ fontWeight: 600, marginBottom: 4, fontFamily: 'inherit' }}>Arguments</div>
              <pre style={{ margin: 0, fontSize: 12 }}>
                {JSON.stringify(callPart.arguments, null, 2)}
              </pre>
            </div>
          )}
          {resultPart && (
            <div style={{ marginTop: Object.keys(callPart.arguments).length > 0 ? 8 : 0 }}>
              <div style={{
                fontWeight: 600,
                marginBottom: 4,
                fontFamily: 'inherit',
                color: resultPart.is_error ? '#ff4d4f' : undefined,
              }}>
                {resultPart.is_error ? 'Error' : 'Result'}
              </div>
              <pre style={{ margin: 0, fontSize: 12 }}>
                {resultPart.content}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ToolCallGroup
